module.exports = __webpack_public_path__ + "assets/img/80c8-io.svg";